export const buildFhirImagingStudyUrl = (studyInstanceUID, basePath = '/fhir') => {
  const uid = String(studyInstanceUID || '').trim();
  const base = String(basePath || '/fhir').replace(/\/$/, '');
  return `${base}/ImagingStudy?identifier=${encodeURIComponent(uid)}`;
};

export const buildFhirPatientUrl = (patientId, basePath = '/fhir') => {
  const id = String(patientId || '').trim();
  const base = String(basePath || '/fhir').replace(/\/$/, '');
  return `${base}/Patient?identifier=${encodeURIComponent(id)}`;
};

export const buildSmartLaunchUrl = ({ patientId = '', studyInstanceUID = '', basePath = '/smart' } = {}) => {
  const base = String(basePath || '/smart').replace(/\/$/, '');
  const params = [];
  if (patientId) params.push(`patient=${encodeURIComponent(patientId)}`);
  if (studyInstanceUID) params.push(`study=${encodeURIComponent(studyInstanceUID)}`);
  return `${base}/launch${params.length ? `?${params.join('&')}` : ''}`;
};
